// extracted by mini-css-extract-plugin
export default {"container":"TextBlock_container__4cjH0","text":"TextBlock_text__GsrRk"};